import { z } from "zod";
import { surfaceEnvelope } from "./shared";

export const MapNodeSchema = z.object({
  id: z.string(),
  title: z.string().nullish(),
  topic: z.string(),
  site: z.string(),
  project_name: z.string().nullish(),
  last_captured_at: z.string(),
}).passthrough();

export const MapEdgeSchema = z.object({ source: z.string(), target: z.string(), similarity: z.number() }).passthrough();

export const MapSurfaceDataSchema = z.object({
  nodes: z.array(MapNodeSchema).default([]),
  edges: z.array(MapEdgeSchema).default([]),
}).passthrough();

export const MapSurfaceResponseSchema = surfaceEnvelope(MapSurfaceDataSchema);

export type MapNode = z.infer<typeof MapNodeSchema>;
export type MapEdge = z.infer<typeof MapEdgeSchema>;
export type MapSurfaceData = z.infer<typeof MapSurfaceDataSchema>;
export type MapSurfaceResponse = z.infer<typeof MapSurfaceResponseSchema>;
